import React from 'react';
import type {FCWithChildren} from 'types';

/** Custom tool with any content */
export const Content: FCWithChildren = ({children}) => {
  return <>{children}</>;
};
